import {Component} from '@angular/core';


@Component({
    selector: 'db-sign-up-trial',
    templateUrl: './sign-up-trial.component.html',
    styleUrls: ['./sign-up-trial.component.scss'],
    standalone: false
})
export class SignUpTrialComponent {

  constructor() {}

}
